export default {
  addPost: "/position/add",
  editPost: "/position/modify",
  removePost: "/position/delete",
  addDepart: "/department/insert",
  editDepart: "/department/modify",
  moveDepart: "/department/removegroup",
  removeDepart: "/department/delete/{id}",
  setLeader: "/department/setleader",
  getPostByDepartId: "/position/organizeposition",
}



// WEBPACK FOOTER //
// ./src/api/config/organize.js